import { takeLatest, call, put, select } from "redux-saga/effects";
import {
  GET_AZURE_METRICS_AVAILABILITY,
  GET_AZURE_METRICS_AVAILABILITY_SUCCESS,
  GET_AZURE_METRICS_AVAILABILITY_ERROR,
} from "./constant";

import { getAzureMetricsAvailabilityApi } from "./api";

/**
 * action Type of GET_DASHBOARD_INFO
 * @param {Object} action
 */
function* getAzureMetricsAvailabilityList(params) {
  try {
    const provider = yield select(state => state.CloudProviderStore ? state.CloudProviderStore.selectedProvider : "azure");
    const data = yield call(getAzureMetricsAvailabilityApi, params, provider);

    yield put({ type: GET_AZURE_METRICS_AVAILABILITY_SUCCESS, data });
  } catch (error) {
    yield put({ type: GET_AZURE_METRICS_AVAILABILITY_ERROR, error });
  }
}

/**
 * Get Login Saga
 */
export function* manageAzureMetricsAvailabilitySaga() {
  yield takeLatest(
    GET_AZURE_METRICS_AVAILABILITY,
    getAzureMetricsAvailabilityList
  );
}
